export default "__VITE_ASSET__1ydcA2jg__"